import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environments';

@Injectable({
  providedIn: 'root'
})
export class WhiteLabelService {

  constructor(private httpClient: HttpClient) { }

  addLogo(formData: FormData) {
    return this.httpClient.post<any>(`${environment.whiteLabel}/logo`, formData);
  }

  deleteLogo(id:number) {
    return this.httpClient.delete<any>(`${environment.whiteLabel}/logo/${id}`);
  }
}
